import { ReactElement, memo } from 'react';

import { InjectedModule, InjectedModuleProps } from '@beeline/lk-utils';

import { IS_DEBUG } from ':constants';

export const WidgetInjected = memo(function WidgetInjected({
  host,
  name,
  errorElement,
  fallback,
}: InjectedModuleProps): ReactElement {
  const mode = IS_DEBUG ? 'open' : 'closed';

  return (
    <InjectedModule
      host={host}
      name={name}
      mode={mode}
      fallback={fallback}
      errorElement={errorElement}
    />
  );
});
